import React from 'react'
import {
  Grid,
  Paper,
  Typography,
  makeStyles,
  withStyles
} from '@material-ui/core'

const CustomTypography = withStyles(theme => ({
  root: {
    textAlign: 'center'
  }
}))(Typography)

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing()
  }
}))
const CardsQuantidade = ({
  quantidadeFila,
  quantidadeFilaAnaliseDocumentos,
  quantidadeAnalise,
  quantidadePendete,
  quantidadePendeteGestor
}) => {
  const classes = useStyles()

  return (
    <>
      <Grid item xs={12}>
        <Paper className={classes.card}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} lg>
              <CustomTypography gutterBottom>
                Quantidade na Fila: Completa
              </CustomTypography>
              <CustomTypography variant="h5">{quantidadeFila}</CustomTypography>
            </Grid>
            <Grid item xs={12} sm={6} lg>
              <CustomTypography gutterBottom>
                Quantidade na Fila: Documentos
              </CustomTypography>
              <CustomTypography variant="h5">
                {quantidadeFilaAnaliseDocumentos}
              </CustomTypography>
            </Grid>
            <Grid item xs={12} sm={6} lg>
              <CustomTypography gutterBottom>
                Quantidade em Análise
              </CustomTypography>
              <CustomTypography variant="h5">
                {quantidadeAnalise}
              </CustomTypography>
            </Grid>
            <Grid item xs={12} sm={6} lg>
              <CustomTypography gutterBottom>
                Quantidade em Pendente
              </CustomTypography>
              <CustomTypography variant="h5">
                {quantidadePendete}
              </CustomTypography>
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <CustomTypography gutterBottom>
                Quantidade em Pendente Monitoramento
              </CustomTypography>
              <CustomTypography variant="h5">
                {quantidadePendeteGestor}
              </CustomTypography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  )
}

export default React.memo(CardsQuantidade)
